<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Multi Level Progress Bar
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Multi Level Progress Bar</h2>
  <div class="content__tools-wrap" *ngIf="isBrowser">
    <div class="content__row" *ngFor="let item of progressData;let inx=index">
      <input type="text" placeholder="Name" [(ngModel)]="item.name" [attr.aria-label]="'Progress '+item.name"
        class="c-input-group__control" />
      <input type="number" placeholder="Number" [(ngModel)]="item.value" min="0" [max]="item.maxValue"
        [attr.aria-label]="'Progress '+item.name+' Value'" class="c-input-group__control"
        (input)="getSumValues($event,item)" />
      <label for="color-option{{inx}}" class="content__row-label">color option</label>
      <select [(ngModel)]="item.color" class="c-input-group__control" id="color-option{{inx}}">
        <ng-container *ngFor="let value of colorsList">
          <option [value]="value.code">{{ value.text }}</option>
        </ng-container>
      </select>
    </div>
  </div>
  <div class="u-mt-16">
    <maced-multi-level-progress-bar progressBarId="progressBar1" [progressTitle]="progressTitle"
      [progressData]="progressData" [totalValue]="totalValue" [icon]="icon">
    </maced-multi-level-progress-bar>
  </div>
</div>